import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 30,
  },
  section: {
    marginBottom: 10,
  },
  header: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: "space-between",
    marginBottom: 10,
    marginTop: 10,
  },
  title: {
    fontSize: 14,
    fontFamily: "Times-Bold",
  },
  spacing: {
    marginTop: 10,
  },
  subtitle: {
    fontSize: 12,
  },
  table: {
    flexDirection: "column",
    border: "1px solid black",
    marginTop: 8,
    borderRight: 0,
    borderBottom: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCol: {
    flex: 1,
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    padding: 3,
    fontSize: 10,
  },
  tableSpacing: {
    width: 15, // fixed width spacing
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
  },
  tableColHead: {
    fontFamily: "Times-Bold",
    flex: 1,
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    padding: 3,
    fontSize: 10,
    backgroundColor: "#d3d3d3",
  },
  boldText: {
    fontFamily: "Times-Bold",
  },
});

const TrialDogResultsPremeir = ({ results }) => {

  const renderFound = (found, location) => {
    if(!location) return "";
    if (found === true) return "Yes"; 
    if (found === false) return "No";
    return "";
  };

  return (
    <Document>
      {results.data.map((item, index) => (
        <Page size="A4" style={styles.page} key={index}>
          <View style={styles.section}>
            <View style={styles.header}>
              <Text style={styles.title}>{results.trialName}, {results.trialLocation}</Text>
              <Text style={styles.title}>{moment.utc(results.date).format("MM/DD/YYYY")}</Text>
            </View>

            <Text style={styles.title}>
              Trial Results for {item?.handler} & {
              item?.dogName}
            </Text>

            <View style={styles.table}>
              <View style={[styles.tableRow]}>
                <Text style={[styles.tableColHead, { flex: 1 }]}>Overall</Text>
              </View>
              <View style={styles.tableRow}>
                  <Text style={styles.tableCol}>Total Points:</Text>
                  <Text style={styles.tableCol}>{item.totalPoints}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>Total Hides Found:</Text>
                  <Text style={styles.tableCol}>{item.totalHidesFound}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>Faults</Text>
                  <Text style={styles.tableCol}>{item.totalFaults}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>Place</Text>
                  <Text style={styles.tableCol}>{item.totalPlace}</Text>
              </View>
            </View>
            {item.awards?.length > 0 && (
              <Text style={[styles.title, styles.spacing]}>
                Awards:&nbsp;
                <Text style={styles.subtitle}>
                  {item.awards.map(a => a.award).join(', ')}
                </Text>
              </Text>
            )}
            {item?.result?.map((subItem, subIndex) => (
              <View key={subIndex} style={styles.table}>
                <View style={[styles.tableRow]}>
                  <Text style={styles.tableColHead}>
                    {subItem.searchName}
                  </Text>
                  <Text style={styles.tableColHead}></Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableColHead}>
                    {subItem.result.div}
                  </Text>
                  <Text style={styles.tableColHead}></Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableColHead}>Hide</Text>
                  <Text style={styles.tableColHead}>Found</Text>
                </View>

                <View style={styles.tableRow}>
                  <Text style={styles.tableCol}>Hides Set</Text>
                  <Text style={styles.tableCol}>{subItem.result.hidesSet}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>Time Limit</Text>
                  <Text style={styles.tableCol}>{subItem.result.timeLimit}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>{subItem.result.hide1Location}</Text>
                  <Text style={styles.tableCol}>{renderFound(subItem.result.hide1Found, subItem.result.hide1Location)}</Text>
                </View>

                <View style={styles.tableRow}>
                  <Text style={styles.tableCol}>Hides Found</Text>
                  <Text style={styles.tableCol}>{subItem.result.hidesFound}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>Your Time</Text>
                  <Text style={styles.tableCol}>{subItem.result.time}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>{subItem.result.hide2Location}</Text>
                  <Text style={styles.tableCol}>{renderFound(subItem.result.hide2Found, subItem.result.hide2Location)}</Text>
                </View>

                <View style={styles.tableRow}>
                  <Text style={styles.tableCol}>False Alerts</Text>
                  <Text style={styles.tableCol}>{subItem.result.falseAlerts}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>Time Out</Text>
                  <Text style={styles.tableCol}>{subItem.result.timeOut}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>{subItem.result.hide3Location}</Text>
                  <Text style={styles.tableCol}>{renderFound(subItem.result.hide3Found, subItem.result.hide3Location)}</Text>
                </View>

                <View style={styles.tableRow}>
                  <Text style={styles.tableCol}>Points</Text>
                  <Text style={styles.tableCol}>{subItem.result.points}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>Place</Text>
                  <Text style={styles.tableCol}>{subItem.result.place}</Text>
                  <View style={styles.tableSpacing} />
                  <Text style={styles.tableCol}>{subItem.result.hide4Location}</Text>
                  <Text style={styles.tableCol}>{renderFound(subItem.result.hide4Found, subItem.result.hide4Location)}</Text>
                </View>
                {subItem.result.hide5Location && (
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCol}></Text>
                    <Text style={styles.tableCol}></Text>
                    <View style={styles.tableSpacing} />
                    <Text style={styles.tableCol}></Text>
                    <Text style={styles.tableCol}></Text>
                    <View style={styles.tableSpacing} />
                    <Text style={styles.tableCol}>{subItem.result.hide5Location}</Text>
                    <Text style={styles.tableCol}>{renderFound(subItem.result.hide5Found, subItem.result.hide5Location)}</Text>
                  </View>
                )}
                  {subItem.result.hide6Location && (
                    <View style={styles.tableRow}>
                      <Text style={styles.tableCol}></Text>
                      <Text style={styles.tableCol}></Text>
                      <View style={styles.tableSpacing} />
                      <Text style={styles.tableCol}></Text>
                      <Text style={styles.tableCol}></Text>
                      <View style={styles.tableSpacing} />
                      <Text style={styles.tableCol}>{subItem.result.hide6Location}</Text>
                      <Text style={styles.tableCol}>{renderFound(subItem.result.hide6Found, subItem.result.hide6Location)}</Text>
                    </View>
                )}
                {subItem.result.hide7Location && (
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCol}></Text>
                    <Text style={styles.tableCol}></Text>
                    <View style={styles.tableSpacing} />
                    <Text style={styles.tableCol}></Text>
                    <Text style={styles.tableCol}></Text>
                    <View style={styles.tableSpacing} />
                    <Text style={styles.tableCol}>{subItem.result.hide7Location}</Text>
                    <Text style={styles.tableCol}>{renderFound(subItem.result.hide7Found, subItem.result.hide7Location)}</Text>
                  </View>
                )}
                <View style={styles.tableRow}>
                  <Text style={[styles.tableCol, { flex: 4 }]}>
                    Judge Notes: {subItem.result.judgeNotes}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default TrialDogResultsPremeir;
